import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { convertToNumber, formatMoney } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    row: {
        height: 24,
        fontSize: 11,
        fontStyle: 'bold',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: '#000000'
    },
    description: {
        width: '88%',
        paddingRight: 8,
        textAlign: 'right'
    },
    total: {
        width: '12%',
        paddingRight: 8,
        textAlign: 'right',
        fontFamily: 'Helvetica-Bold'
    },
});


const MovimentsTableFooter = ({ items }) => {
    let totalValue = 0, value = 0;

    items.forEach((item) => {
        value = (typeof item.value === 'string') ? convertToNumber(item.value, 5) : item.value;
        if(item.type === 'Receber')
            totalValue += value;
        else 
            totalValue -= value;
    });

    return (
        <View style={styles.row}>
            <Text style={styles.description}>TOTAL:</Text>
            <Text style={styles.total}>R$ {formatMoney(totalValue + '')}</Text>
        </View>
    );
};

export default MovimentsTableFooter